/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import {
  IDepartmentData,
  IFilterUserManagement,
  IPermissionData,
  IUserData,
  IUserEdit,
  IUserManagementData,
  IUserManagementState,
} from "types/models/user-management";
import { RootState } from "types/reducer";

const initialState: IUserManagementState = {
  user_management: {
    users: [],
    current_page: 1,
    page_size: 10,
    total_pages: 1,
  },
  permissions: [],
  filter: {
    page: 1,
    page_size: null,
    username: "",
    current_page: '',
  },
  departments: []
};

const UserManagementSlice = createSlice({
  name: "user_management",
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<IFilterUserManagement>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    fetchDataPermission(state) { },
    fetchDataPermissionSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IPermissionData[]>
    ) {
      state.permissions = action.payload;
    },
    clearFilter(state: Draft<IUserManagementState>) {
      state.filter = {
        page: null,
        page_size: null,
        username: "",
      };
    },
    deleteUser(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    deleteUserSuccess(state: Draft<IUserManagementState>) { },
    editUser(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IUserEdit>
    ) { },
    editUserSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IUserEdit>
    ) { },
    createNewUser(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IUserEdit>
    ) { },
    createNewUserSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IUserEdit>
    ) { },
    fetchDataUser() { },
    fetchDataUserSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<IUserManagementData>
    ) {
      state.filter = {
        ...state.filter,
        page: action.payload.current_page,
        page_size: action.payload.page_size,
      };
      state.user_management = {
        ...state.user_management,
        users: action.payload.users.map((user: IUserData, idx: number) => {
          return {
            ...user,
            stt: idx + 1
          }
        }),
        current_page: action.payload.current_page,
        page_size: action.payload.page_size,
        total_pages: action.payload.total_pages,
      };
    },
    fetchDataDepartment() { },
    fetchDataDepartmentSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) {
      state.departments = action.payload.map((dep: IDepartmentData) => {
        return {
          label: dep,
          value: dep
        }
      })
    },
    clearStateUserManagement(state: Draft<IUserManagementState>) {
      state.user_management = initialState.user_management;
      state.filter = initialState.filter;
      state.permissions = initialState.permissions;
    },
    editUserLLM(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    editUserLLMSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    editUserConfigure(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    editUserConfigureSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    updateStatusUser(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    updateStatusUserSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    updateInfoMultiUser(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    updateInfoMultiUserSuccess(
      state: Draft<IUserManagementState>,
      action: PayloadAction<any>
    ) { },
    deleteAllHistory(state, action: PayloadAction<string>) { },
  },
});

// Actions

export const fetchDataUser = UserManagementSlice.actions.fetchDataUser;
export const fetchDataUserSuccess =
  UserManagementSlice.actions.fetchDataUserSuccess;

export const fetchDataDepartment = UserManagementSlice.actions.fetchDataDepartment;
export const fetchDataDepartmentSuccess =
  UserManagementSlice.actions.fetchDataDepartmentSuccess;

export const deleteUser = UserManagementSlice.actions.deleteUser;
export const deleteUserSuccess = UserManagementSlice.actions.deleteUserSuccess;

export const editUser = UserManagementSlice.actions.editUser;
export const editUserSuccess = UserManagementSlice.actions.editUserSuccess;

export const editUserLLM = UserManagementSlice.actions.editUserLLM;
export const editUserLLMSuccess = UserManagementSlice.actions.editUserLLMSuccess;

export const editUserConfigure = UserManagementSlice.actions.editUserConfigure;
export const editUserConfigureSuccess = UserManagementSlice.actions.editUserConfigureSuccess;

export const updateInfoMultiUser = UserManagementSlice.actions.updateInfoMultiUser;
export const updateInfoMultiUserSuccess = UserManagementSlice.actions.updateInfoMultiUserSuccess;

export const updateStatusUser = UserManagementSlice.actions.updateStatusUser;
export const updateStatusUserSuccess = UserManagementSlice.actions.updateStatusUserSuccess;

export const createNewUser = UserManagementSlice.actions.createNewUser;
export const createNewUserSuccess =
  UserManagementSlice.actions.createNewUserSuccess;

export const deleteAllHistory = UserManagementSlice.actions.deleteAllHistory;

export const setFilter = UserManagementSlice.actions.setFilter;
export const clearFilter = UserManagementSlice.actions.clearFilter;
export const clearStateUserManagement =
  UserManagementSlice.actions.clearStateUserManagement;

// Selectors
export const getPermissionData = (state: RootState) =>
  state.user_management.permissions;
export const getUserManagementData = (state: RootState) =>
  state.user_management.user_management;
export const getFilterUserManagement = (state: RootState) =>
  state.user_management.filter;
export const getDepartments = (state: RootState) =>
  state.user_management.departments;

// Reducer
const UserManagementReducer = UserManagementSlice.reducer;
export default UserManagementReducer;
